import React from 'react';
import Spinner from '@atlaskit/spinner';
var crimpLogo = require('src/assets/logo/favicon-64.png');
var selfStyles = require('./SpinnerCrimp.scss');
var SpinnerCrimp = function (props) {
    var spinnerSize;
    switch (props.size) {
        case 'large':
            spinnerSize = 80;
            break;
        case 'medium':
            spinnerSize = 60;
            break;
        default:
            spinnerSize = 40;
    }
    return (React.createElement("div", { className: selfStyles.wrapper + " " + selfStyles[props.size] },
        React.createElement("img", { src: crimpLogo }),
        React.createElement(Spinner, { size: spinnerSize })));
};
SpinnerCrimp.defaultProps = {
    size: 'small',
};
export default SpinnerCrimp;



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/utilities/SpinnerCrimp.tsx
// module id = 119
// module chunks = 0